import { ProcesosRutas, GetResponseBody, GetHeaderRequest, GetHeaderRequestFormData } from './RutasConfig';


export const Picking_Obtener_Opciones_Menu = async (pToken, opciones) => {
    const data = { opciones };
    const result = await fetch(ProcesosRutas.Picking_Obtener_Opciones_Menu, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};
export const Picking_Traslado_Fue_Aplicado = async (pToken, empresaId, sucursalId, trasladoId) => {
    const data = { empresaId, sucursalId, trasladoId };
    const result = await fetch(ProcesosRutas.Picking_Traslado_Fue_Aplicado, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};
export const Picking_Suborden_Requiere_Traslado = async (pToken, empresaId, sucursalId, callCenterId, ordenId) => {
    const data = { empresaId, sucursalId, callCenterId, ordenId };
    const result = await fetch(ProcesosRutas.Picking_Suborden_Requiere_Traslado, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};
export const Picking_Orden_Requiere_Traslado = async (pToken, empresaId, callCenterId, ordenId) => {
    const data = { empresaId, callCenterId, ordenId };
    const result = await fetch(ProcesosRutas.Picking_Orden_Requiere_Traslado, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};
export const Picking_Obtener_Intervalo_Recoger_Tienda = async (pToken, empresaId, sucursalId) => {
    const data = { empresaId, sucursalId };
    const result = await fetch(ProcesosRutas.Picking_Obtener_Intervalo_Recoger_Tienda, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};
export const Picking_Suborden_Esta_Pendiente = async (pToken, empresaId, sucursalId, callCenterId, ordenId) => {
    const data = { empresaId, sucursalId, callCenterId, ordenId };
    const result = await fetch(ProcesosRutas.Picking_Suborden_Esta_Pendiente, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};
export const Picking_Orden_Esta_Pendiente = async (pToken, empresaId, callCenterId, ordenId) => {
    const data = { empresaId, callCenterId, ordenId };
    const result = await fetch(ProcesosRutas.Picking_Orden_Esta_Pendiente, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};
export const Picking_Suborden_Esta_Auditada = async (pToken, ordenId, empresaId, callCenterId, sucursalId) => {
    const data = { ordenId, empresaId, callCenterId, sucursalId };
    const result = await fetch(ProcesosRutas.Picking_Suborden_Esta_Auditada, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};
export const Picking_Obtener_Sucursales_Orden_Seg_Usuario = async (pToken, empresaId, callCenterId, ordenId) => {
    const data = { empresaId, callCenterId, ordenId };
    const result = await fetch(ProcesosRutas.Picking_Obtener_Sucursales_Orden_Seg_Usuario, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};
export const Picking_Obtener_Traslado = async (pToken, empresaId, sucursalId, ordenId, callCenterId) => {
    const data = { empresaId, sucursalId, ordenId, callCenterId };
    const result = await fetch(ProcesosRutas.Picking_Obtener_Traslado, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};
export const Picking_Aplicar_Traslado = async (pToken, empresaId, sucursalId, ordenId, callCenterId, usuarioId) => {
    const data = { empresaId, sucursalId, ordenId, callCenterId, usuarioId };
    const result = await fetch(ProcesosRutas.Picking_Aplicar_Traslado, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};
export const Picking_Aplicar_Picking = async (pToken, empresaId, sucursalId, ordenId, callCenterId, urlServicioEcommerce, usuarioId) => {
    const data = { empresaId, sucursalId, ordenId, callCenterId, urlServicioEcommerce, usuarioId };
    const result = await fetch(ProcesosRutas.Picking_Aplicar_Picking, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};
export const Picking_Auditar_Producto_Orden = async (pToken, empresaId, sucursalId, ordenId, callCenterId, productoId, cantidadAuditada) => {
    const data = { empresaId, sucursalId, ordenId, callCenterId, productoId, cantidadAuditada };
    const result = await fetch(ProcesosRutas.Picking_Auditar_Producto_Orden, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};
export const Picking_Obtener_Estatus_Producto_Orden = async (pToken, empresaId, sucursalId, ordenId, callCenterId, productoId) => {
    const data = { empresaId, sucursalId, ordenId, callCenterId, productoId };
    const result = await fetch(ProcesosRutas.Picking_Obtener_Estatus_Producto_Orden, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};
export const Picking_Obtener_Productos_Orden = async (pToken, empresaId, callCenterId, sucursalFacturaId, ordenId) => {
    const data = { empresaId, callCenterId, sucursalFacturaId, ordenId };
    const result = await fetch(ProcesosRutas.Picking_Obtener_Productos_Orden, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};
export const Picking_Obtener_Sucursales_Apoyo = async (pToken, EmpresaId, CallCenterId) => {
    const data = { EmpresaId, CallCenterId };
    const result = await fetch(ProcesosRutas.Picking_Obtener_Sucursales_X_Usuario, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};
export const Picking_Obtener_Ordenes = async (pToken, empresaId, callCenterId, sucursalFacturaId, fechaActiva, sucursalApoyoId = null, estado = null) => {
    const [fechaActivaIni, fechaActivaFin] = fechaActiva;
    const data = { empresaId, callCenterId, sucursalFacturaId, fechaActivaIni, fechaActivaFin, sucursalApoyoId, estado };
    const result = await fetch(ProcesosRutas.Picking_Obtener_Ordenes, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};


export const AR_Obtener_Productos_Ordenes = async (pToken, EmpresaId, CallCenterId, ordenesIds) => {
    const data = { EmpresaId, CallCenterId, ordenesIds };
    const result = await fetch(ProcesosRutas.AR_Obtener_Productos_Ordenes, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const AR_Obtener_Productos_Orden = async (pToken, EmpresaId, CallCenterId, pOrden) => {
    const data = { EmpresaId, CallCenterId, pOrden };
    const result = await fetch(ProcesosRutas.AR_Obtener_Productos_Orden, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const AR_Desasignar_Repartidor = async (pToken, empresaId, callCenterId, sucursalId, ordenId, repartidorId) => {
    const data = { empresaId, callCenterId, sucursalId, ordenId, repartidorId };
    const result = await fetch(ProcesosRutas.AR_Desasignar_Repartidor, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const AR_Asignar_Repartidor = async (pToken, empresaId, callCenterId, sucursalId, ordenId, repartidorId, enRuta, UsuarioId) => {
    const data = { empresaId, callCenterId, sucursalId, ordenId, repartidorId, enRuta, UsuarioId };
    const result = await fetch(ProcesosRutas.AR_Asignar_Repartidor, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const AR_Repartidor_En_Ruta = async (pToken, empresaId, callCenterId, repartidorId, ordenes, setEnRoute, UsuarioId) => {
    const data = { empresaId, callCenterId, repartidorId, ordenes, setEnRoute, UsuarioId };
    const result = await fetch(ProcesosRutas.AR_Repartidor_En_Ruta, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Obtener_Configuraciones = async (pToken, empresaId, callCenterId, sucursalId) => {
    const data = { empresaId, callCenterId, sucursalId };
    const result = await fetch(ProcesosRutas.Obtener_Configuraciones, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
}

export const Guardar_Entrega_Repartidores = async (pToken, pEntrega, pDetalle, enRuta) => {
    const data = { pEntrega, pDetalle, enRuta, pToken };
    const result = await fetch(ProcesosRutas.Guardar_Entrega_Repartidores, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
}

export const Eliminar_Orden_Entrega_Ruta = async (pToken, pEntrega, pOrden) => {
    const data = { pEntrega, pOrden };
    const result = await fetch(ProcesosRutas.Eliminar_Orden_Entrega_Ruta, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
}
//////////////////// Repartidores ///////////////////////////
export const Obtener_Repartidores = async (pToken, empresaId, callCenterId, sucursalId) => {
    const data = { empresaId, callCenterId, sucursalId }
    const result = await fetch(ProcesosRutas.Obtener_Repartidores, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
}

////////////////////Analisis Timpor Orden ///////////////////////////////////

export const AnalisisTiempoOrden_Listar = async (pToken, EmpresaId, CallCenterId, pOrdenId) => {
    const data = { EmpresaId, CallCenterId, pOrdenId };
    const result = await fetch(ProcesosRutas.AnalisisTiempoOrden_Listar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
}

//////////////////// Control Monitor///////////////////////////

export const Control_Monitoreo_Detalle = async (pToken, EmpresaId, SucursalId) => {
    const data = { EmpresaId, SucursalId };
    const result = await fetch(ProcesosRutas.Control_Monitoreo_Detalle, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

////////////////////Ordenes Par ///////////////////////////////////





export const Listar_Ordenes_A_Pantalla_Gen = async (pToken, EmpresaId, CallCenterId, pOrden, pEsPar) => {
    const data = { EmpresaId, CallCenterId, pOrden, pEsPar };
    const result = await fetch(ProcesosRutas.Listar_Ordenes_A_Pantalla_Gen, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};



export const Exp_Validar_Despacho_Orden_Ecommerce = async (pToken, EmpresaId, CallCenterId, pOrden, SucursalId, Datos, pEsPicking = false) => {
    const data = { EmpresaId: EmpresaId, CallCenterId: CallCenterId, pOrden: pOrden, SucursalId: SucursalId, Datos: Datos, EsPicking: pEsPicking };
    const result = await fetch(ProcesosRutas.Exp_Validar_Despacho_Orden_Ecommerce, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Exp_Orden_Encabezado_Par_Detalle = async (pToken, EmpresaId, CallCenterId, pOrdenId) => {
    const data = { EmpresaId, CallCenterId, pOrdenId };
    const result = await fetch(ProcesosRutas.Exp_Orden_Encabezado_Par_Detalle, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
}

export const Liquidar_Orden_Express = async (pToken, EmpresaId, CallCenterId, pOrdenId, RepartidorId, pUsuario) => {
    const data = { EmpresaId, CallCenterId, pOrdenId, RepartidorId, pUsuario };
    const result = await fetch(ProcesosRutas.Liquidar_Orden_Express, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Obtener_Ordenes_Sin_Asignar = async (pToken, empresaId, callCenterId, sucursalId, estadosOrden, pFecha) => {
    const data = { pToken, empresaId, callCenterId, sucursalId, estadosOrden, pFecha };
    const result = await fetch(ProcesosRutas.Obtener_Ordenes_Sin_Asignar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });

    return await GetResponseBody(result);
};

////////////////////Ordenes ///////////////////////////////////

export const Exp_Orden_Encabezado_Detalle = async (pToken, EmpresaId, CallCenterId, pOrdenId) => {
    const data = { EmpresaId, CallCenterId, pOrdenId };
    const result = await fetch(ProcesosRutas.Exp_Orden_Encabezado_Detalle, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
}

////////////////////Ordenes TIPO PAGO ///////////////////////////////////

export const Exp_Orden_Tipo_Pagos = async (pToken, EmpresaId, CallCenterId, pOrdenId, EsPar) => {
    const data = { EmpresaId, CallCenterId, pOrdenId, EsPar };
    const result = await fetch(ProcesosRutas.Exp_Orden_Tipo_Pagos, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Obtener_Formas_Pago_Orden = async (pToken, EmpresaId, CallCenterId, pOrdenId) => {
    const data = { EmpresaId, CallCenterId, pOrdenId };
    const result = await fetch(ProcesosRutas.Obtener_Formas_Pago_Orden, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

////////////////Parametros Generales/////////////////////////


export const Listar_ParametrosGenerales = async (pToken) => {
    const result = await fetch(ProcesosRutas.Listar_ParametrosGenerales, {
        headers: GetHeaderRequestFormData(pToken)
    });
    return await GetResponseBody(result);
};

////////////////Parametros Cadena/////////////////////////

export const Listar_ParametrosCadena = async (pToken, pEmpresa, pCadena) => {
    const data = { pEmpresa, pCadena };
    const result = await fetch(ProcesosRutas.Listar_ParametrosCadena, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

///////////////////SubOrdenes ///////////////////////////////


export const ExpSuborden_Encabezado_Listar_Gen = async (pToken, EmpresaId, CallCenterId, OrdenId, EsPar) => {
    const data = { EmpresaId, CallCenterId, OrdenId, EsPar };
    const result = await fetch(ProcesosRutas.ExpSuborden_Encabezado_Listar_Gen, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};
